export default {
	// 巡检账号
	addInspection: '/account/inspection', // 新建
	editInspection: '/account/inspection/{id}', // 修改
	delInspection: '/account/inspection/{id}', // 删除
	editInspectionCustomer: '/account/inspection/customer/{id}', // 修改巡检客户
	getInspectionHistoryList: '/account/inspection/history-log/list', // 历史记录列表
	getInspectionList: '/account/inspection/list', // 获取巡检账号列表
};
